var _g, _rect, _rect2, _g2, _rect3, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserDropdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 35,
    viewBox: "0 0 67 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2122_351)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.9657,
    height: 34.9657,
    rx: 17.4828,
    fill: "#D7E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4834 17.4828C20.7031 17.4828 23.311 14.875 23.311 11.6552C23.311 8.43546 20.7031 5.82761 17.4834 5.82761C14.2636 5.82761 11.6557 8.43546 11.6557 11.6552C11.6557 14.875 14.2636 17.4828 17.4834 17.4828ZM17.4834 20.3966C13.5934 20.3966 5.82812 22.3489 5.82812 26.2243V33.5088C5.82812 34.3101 6.48373 34.9657 7.28503 34.9657H27.6817C28.483 34.9657 29.1386 34.3101 29.1386 33.5088V26.2243C29.1386 22.3489 21.3733 20.3966 17.4834 20.3966Z",
    fill: "#132543"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.7764,
    y: 23.0774,
    width: 11.6147,
    height: 11.6147,
    rx: 5.80733,
    fill: "#0060FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2122_351",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 25,
    width: 9,
    height: 9
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4854,
    y: 25.127,
    width: 8.19859,
    height: 8.19859,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2122_351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.194 31.6177H27.6722L30.6186 28.6713L30.1403 28.193L27.194 31.1394V31.6177ZM32.0789 28.176L30.6271 26.7412L31.1054 26.263C31.2363 26.132 31.3972 26.0665 31.5879 26.0665C31.7786 26.0665 31.9395 26.132 32.0704 26.263L32.5487 26.7412C32.6796 26.8722 32.7479 27.0301 32.7536 27.2152C32.7593 27.4002 32.6967 27.5582 32.5657 27.6892L32.0789 28.176ZM31.5836 28.6798L27.9626 32.3009H26.5107V30.849L30.1318 27.228L31.5836 28.6798Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2122_351",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 5,
    width: 25,
    height: 25
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.3916,
    y: 29.4828,
    width: 24,
    height: 24,
    transform: "rotate(-180 66.3916 29.4828)",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2122_351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6014 15.7329C57.0065 15.7329 57.287 15.9178 57.4427 16.2877C57.5985 16.6575 57.5341 16.9848 57.2495 17.2694L55.0149 19.504C54.9213 19.5976 54.8226 19.6662 54.7187 19.7097C54.6149 19.7533 54.5027 19.7751 54.3822 19.7751C54.2617 19.7751 54.1495 19.7533 54.0457 19.7097C53.9418 19.6662 53.8431 19.5976 53.7495 19.504L51.5149 17.2694C51.2303 16.9848 51.1659 16.6575 51.3217 16.2877C51.4774 15.9178 51.7579 15.7329 52.163 15.7329L56.6014 15.7329Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2122_351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.9657,
    height: 34.9657,
    rx: 17.4828,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDropdown);
export default __webpack_public_path__ + "static/media/user-dropdown.fd836ed5e5d2b773681e0d8dd32825e3.svg";
export { ForwardRef as ReactComponent };